import { configure } from '@mobi/ds'
import { ENV } from 'gatsby-env-variables'
import Root from './src/Root'
import analytics from '@mobi/libraries/analytics'
import makeTrackings from './src/utils/make'
import { isPivo } from 'utils/isPivo'

configure({
  originFonts: 'extern',
  fonts: {
    ItauDisplay: [900],
    ItauText: [400, 700],
  },
  setStyleVariablesInHTML: false,
})

const stagingMake = {
  writeKey: 'wk_2EP5qJVmuft6CwtbRZDbicz1Alq',
  sourceKey: 'src_2EP5qEV0lil4v0Id6TsRQtUzn4Q',
}

const productionMake = {
  writeKey: 'wk_2EP5iKLBYABf6caUx5sqSRhrQuC',
  sourceKey: 'src_2EP5iNhah7PotvGssqbAAaK5GMT',
}

const makeTagular = ENV === 'prod' ? productionMake : stagingMake

if (!isPivo()) {
  analytics.setup({
    makeTagular,
    trackings: makeTrackings,
  })
}

export const wrapRootElement = Root
